var map = {
	"./ab.png": 9759,
	"./ad.png": 4328,
	"./ae.png": 3844,
	"./af.png": 9769,
	"./ag.png": 6956,
	"./ai.png": 9297,
	"./al.png": 5340,
	"./am.png": 7975,
	"./an.png": 2584,
	"./ao.png": 7139,
	"./aq.png": 1789,
	"./ar.png": 8770,
	"./as.png": 9224,
	"./at.png": 8307,
	"./au.png": 11,
	"./aw.png": 4465,
	"./ax.png": 9610,
	"./az.png": 7424,
	"./ba.png": 1229,
	"./bb.png": 4231,
	"./bd.png": 2836,
	"./be.png": 4526,
	"./bf.png": 7952,
	"./bg.png": 8818,
	"./bh.png": 4382,
	"./bi.png": 1144,
	"./bj.png": 9973,
	"./bl.png": 5895,
	"./bm.png": 101,
	"./bn.png": 8881,
	"./bo.png": 3941,
	"./bq.png": 2626,
	"./br.png": 8581,
	"./bs.png": 5762,
	"./bt.png": 1323,
	"./bw.png": 4975,
	"./by.png": 4004,
	"./bz.png": 3935,
	"./ca.png": 3709,
	"./cc.png": 4800,
	"./cd.png": 2632,
	"./cf.png": 1519,
	"./cg.png": 3722,
	"./ch.png": 737,
	"./ci.png": 940,
	"./ck.png": 6199,
	"./cl.png": 811,
	"./cm.png": 78,
	"./cn.png": 2902,
	"./co.png": 1138,
	"./cr.png": 1068,
	"./cu.png": 6097,
	"./cv.png": 7086,
	"./cw.png": 833,
	"./cx.png": 3304,
	"./cy.png": 5041,
	"./cz.png": 2896,
	"./de.png": 4850,
	"./dj.png": 3279,
	"./dk.png": 7666,
	"./dm.png": 1531,
	"./do.png": 7621,
	"./dz.png": 9920,
	"./ec.png": 5160,
	"./ee.png": 5745,
	"./eg.png": 7495,
	"./eh.png": 1684,
	"./empty.png": 4087,
	"./er.png": 9169,
	"./es.png": 7551,
	"./et.png": 5082,
	"./fi.png": 7923,
	"./fj.png": 2742,
	"./fk.png": 8469,
	"./fm.png": 4041,
	"./fo.png": 478,
	"./fr.png": 1507,
	"./ga.png": 109,
	"./gb.png": 5168,
	"./gd.png": 1673,
	"./ge.png": 5917,
	"./gf.png": 8272,
	"./gg.png": 6862,
	"./gh.png": 8729,
	"./gi.png": 8391,
	"./gl.png": 3093,
	"./gm.png": 6744,
	"./gn.png": 7277,
	"./gp.png": 6822,
	"./gq.png": 1891,
	"./gr.png": 3905,
	"./gt.png": 2059,
	"./gu.png": 6957,
	"./gw.png": 6313,
	"./gy.png": 3663,
	"./hk.png": 5929,
	"./hn.png": 8320,
	"./hr.png": 8236,
	"./ht.png": 3109,
	"./hu.png": 3085,
	"./id.png": 1889,
	"./ie.png": 1587,
	"./il.png": 5111,
	"./im.png": 2547,
	"./in.png": 4099,
	"./io.png": 3472,
	"./iq.png": 3342,
	"./ir.png": 5049,
	"./is.png": 6092,
	"./it.png": 4736,
	"./je.png": 8503,
	"./jm.png": 5518,
	"./jo.png": 9324,
	"./jp.png": 920,
	"./ke.png": 1471,
	"./kg.png": 5588,
	"./kh.png": 2698,
	"./ki.png": 5472,
	"./km.png": 3292,
	"./kn.png": 6121,
	"./kp.png": 4655,
	"./kr.png": 2351,
	"./kw.png": 1271,
	"./ky.png": 7209,
	"./kz.png": 5781,
	"./la.png": 1110,
	"./lb.png": 4613,
	"./lc.png": 5496,
	"./li.png": 3244,
	"./lk.png": 4994,
	"./lr.png": 3186,
	"./ls.png": 1348,
	"./lt.png": 2625,
	"./lu.png": 9048,
	"./lv.png": 2917,
	"./ly.png": 3999,
	"./ma.png": 9337,
	"./mc.png": 6,
	"./md.png": 5962,
	"./me.png": 8149,
	"./mf.png": 2074,
	"./mg.png": 4666,
	"./mh.png": 2800,
	"./mk.png": 2731,
	"./ml.png": 7005,
	"./mm.png": 9278,
	"./mn.png": 6840,
	"./mo.png": 5586,
	"./mp.png": 1801,
	"./mq.png": 4043,
	"./mr.png": 7249,
	"./ms.png": 946,
	"./mt.png": 4748,
	"./mu.png": 5717,
	"./mv.png": 9118,
	"./mw.png": 3155,
	"./mx.png": 9494,
	"./my.png": 3230,
	"./mz.png": 9441,
	"./na.png": 7531,
	"./nc.png": 6909,
	"./ne.png": 2866,
	"./nf.png": 756,
	"./ng.png": 1541,
	"./ni.png": 4780,
	"./nl.png": 5783,
	"./no.png": 9045,
	"./np.png": 8196,
	"./nr.png": 1398,
	"./nu.png": 7418,
	"./nz.png": 5747,
	"./om.png": 8408,
	"./os.png": 999,
	"./other/_ASEAN.png": 7571,
	"./other/_African Union(OAS).png": 663,
	"./other/_Arab League.png": 7927,
	"./other/_CARICOM.png": 1778,
	"./other/_CIS.png": 5966,
	"./other/_Commonwealth.png": 6621,
	"./other/_England.png": 2484,
	"./other/_European Union.png": 314,
	"./other/_Islamic Conference.png": 6694,
	"./other/_Kosovo.png": 7385,
	"./other/_NATO.png": 3100,
	"./other/_Northern Cyprus.png": 9521,
	"./other/_Northern Ireland.png": 3595,
	"./other/_OPEC.png": 5062,
	"./other/_Olimpic Movement.png": 9943,
	"./other/_Red Cross.png": 6391,
	"./other/_Scotland.png": 1853,
	"./other/_Somaliland.png": 3578,
	"./other/_United Nations.png": 9969,
	"./other/_Wales.png": 1895,
	"./pa.png": 1815,
	"./pe.png": 7150,
	"./pf.png": 7756,
	"./pg.png": 6973,
	"./ph.png": 1240,
	"./pk.png": 1987,
	"./pl.png": 6285,
	"./pm.png": 8865,
	"./pn.png": 9857,
	"./pr.png": 1451,
	"./ps.png": 4497,
	"./pt.png": 3462,
	"./pw.png": 1505,
	"./py.png": 2569,
	"./qa.png": 7770,
	"./re.png": 8537,
	"./ro.png": 2619,
	"./rs.png": 2433,
	"./ru.png": 8713,
	"./rw.png": 6315,
	"./sa.png": 2222,
	"./sb.png": 2452,
	"./sc.png": 9371,
	"./sd.png": 958,
	"./se.png": 4881,
	"./sg.png": 7930,
	"./sh.png": 4268,
	"./si.png": 300,
	"./sk.png": 9241,
	"./sl.png": 2888,
	"./sm.png": 9368,
	"./sn.png": 240,
	"./so.png": 7485,
	"./sr.png": 6385,
	"./ss.png": 2027,
	"./st.png": 914,
	"./sv.png": 8104,
	"./sx.png": 7967,
	"./sy.png": 30,
	"./sz.png": 7877,
	"./tc.png": 6593,
	"./td.png": 605,
	"./tg.png": 8223,
	"./th.png": 1894,
	"./tj.png": 1441,
	"./tk.png": 4971,
	"./tl.png": 8227,
	"./tm.png": 1067,
	"./tn.png": 8518,
	"./to.png": 1761,
	"./tr.png": 6196,
	"./tt.png": 6123,
	"./tv.png": 3565,
	"./tw.png": 9366,
	"./tz.png": 1936,
	"./ua.png": 3558,
	"./ug.png": 5704,
	"./um.png": 5137,
	"./us.png": 3753,
	"./uy.png": 3157,
	"./uz.png": 1479,
	"./va.png": 1664,
	"./vc.png": 4508,
	"./ve.png": 6633,
	"./vg.png": 8268,
	"./vi.png": 9168,
	"./vn.png": 2044,
	"./vu.png": 335,
	"./wf.png": 6483,
	"./ws.png": 927,
	"./ye.png": 6925,
	"./yt.png": 6785,
	"./za.png": 4445,
	"./zm.png": 9877,
	"./zw.png": 5694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1898;